import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0cfc7633"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Terms and Conditions")
], -1));
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "columns" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "column" }, "Please review the following important terms and conditions:")
], -1));
const _hoisted_3 = {
    key: 0,
    class: "columns"
};
const _hoisted_4 = { class: "column termsWrapper" };
const _hoisted_5 = { class: "columns mt-4" };
const _hoisted_6 = { style: { "display": "flex", "flex-direction": "row", "width": "100%" } };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "flex-grow": "1" } }, null, -1));
import { onMounted, ref } from "vue";
import { notifyError } from "../../../core/utils";
import InformationCardField from "./InformationCardField.vue";
import SignaturePadField from "./SignaturePadField.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerOnboardingFormTermsPage',
    props: {
        modelValue: {},
        terms: {}
    },
    emits: ['update:modelValue', 'back', 'proceed'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const viewedTerms = ref(null);
        onMounted(() => {
            viewedTerms.value = [...props.modelValue];
        });
        const onTermViewed = (term) => {
            if (viewedTerms.value.includes(term.url))
                return;
            viewedTerms.value.push(term.url);
            emit("update:modelValue", viewedTerms.value);
        };
        const acceptedTerms = ref(false);
        const signaturePad = ref(null);
        const onSubmitClicked = () => {
            for (let term of props.terms) {
                if (!viewedTerms.value.includes(term.url)) {
                    notifyError("Please ensure that you have viewed all terms");
                    return;
                }
            }
            if (!acceptedTerms.value) {
                notifyError("Please ensure that you have agreed to all terms and conditions");
                return;
            }
            if (signaturePad.value.isSignatureEmpty()) {
                notifyError("Please provide your signature");
                return;
            }
            const sigData = signaturePad.value.getSignatureData();
            emit('proceed', sigData);
        };
        return (_ctx, _cache) => {
            const _component_FormCheckboxField = _resolveComponent("FormCheckboxField");
            const _component_SaveButton = _resolveComponent("SaveButton");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _hoisted_2,
                (viewedTerms.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terms, (term) => {
                                return (_openBlock(), _createBlock(InformationCardField, {
                                    key: term.url,
                                    card: term,
                                    size: "small",
                                    viewed: viewedTerms.value.includes(term.url),
                                    onViewed: ($event) => (onTermViewed(term))
                                }, null, 8, ["card", "viewed", "onViewed"]));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_FormCheckboxField, {
                        modelValue: acceptedTerms.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((acceptedTerms).value = $event)),
                        label: "Agree To Terms *",
                        description: "Please check and confirm that you have read, and agree to, all above terms and conditions",
                        boxLabel: "Confirmed"
                    }, null, 8, ["modelValue"]),
                    _createVNode(SignaturePadField, {
                        class: "column",
                        style: { "flex-grow": "1.8" },
                        ref_key: "signaturePad",
                        ref: signaturePad
                    }, null, 512)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_SaveButton, {
                        class: "mr-2",
                        large: "",
                        label: "Back",
                        icon: "fa-chevron-left",
                        onClick: _cache[1] || (_cache[1] = ($event) => (emit('back')))
                    }),
                    _createVNode(_component_SaveButton, {
                        large: "",
                        label: "Next",
                        icon: "fa-chevron-right",
                        iconRight: "",
                        onClick: _cache[2] || (_cache[2] = ($event) => (onSubmitClicked()))
                    })
                ])
            ], 64));
        };
    }
});
